import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';

export function useGetEICFTemplateForFacility(facilityId: number | null | undefined) {
    return useQuery({
        queryKey: [QueryKeys.eicfFacilityActiveTemplate, facilityId],
        queryFn: () => EICFTemplatesApi.getActiveForFacility(facilityId as number),
        enabled: facilityId != null && facilityId > 0,
    });
}
